import { render, staticRenderFns } from "./TaxClassificationPisCofinsForm.vue?vue&type=template&id=22107b48&"
import script from "./TaxClassificationPisCofinsForm.vue?vue&type=script&lang=js&"
export * from "./TaxClassificationPisCofinsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22107b48')) {
      api.createRecord('22107b48', component.options)
    } else {
      api.reload('22107b48', component.options)
    }
    module.hot.accept("./TaxClassificationPisCofinsForm.vue?vue&type=template&id=22107b48&", function () {
      api.rerender('22107b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/invoice/parameters/components/TaxClassificationPisCofinsForm.vue"
export default component.exports